import { GetterTree } from 'vuex'

import { FamilyState } from '@/store/family/types'
import RootState from '@/store/types/RootState'

export default <GetterTree<FamilyState, RootState>>{
  hasAttemptedToLoadData: state => () => state.hasAttemptedToLoadData,

  customer: state => () => state.familyMembers.find(m => m.isCustomer),

  accountHolder: state => () => {
    const foundFamilyMembers = state.familyMembers.filter(person =>
      person.isAccountHolder(),
    )
    return foundFamilyMembers.length > 0 ? foundFamilyMembers[0] : null
  },

  familyMembers: state => () => state.familyMembers,

  familyMemberByUsername: state => username => {
    const foundFamilyMembers = state.familyMembers.filter(
      person => person.username === username,
    )
    return foundFamilyMembers.length > 0 ? foundFamilyMembers[0] : null
  },
}
